var _path, _path2, _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _g2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_personal_information_re_vw8a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 597.189,
    height: 400.273,
    viewBox: "0 0 597.189 400.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M840.5,329.71a187.6,187.6,0,0,1-123.193,176.2,185.455,185.455,0,0,1-33.711,8.848A187.485,187.485,0,0,1,465.43,329.67c0-103.53,83.964-187.494,187.534-187.494A187.521,187.521,0,0,1,840.5,329.71Z",
    transform: "translate(-243.309 -116.971)",
    fill: "#e5e5e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M811.5,754.467a185.459,185.459,0,0,1-33.711,8.848,188.8,188.8,0,0,1-94.176-8.553l8.66-34.751.523-2.086,17.674.068,88.789.318,1.137,3.359Z",
    transform: "translate(-337.501 -365.531)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 162.9,
    height: 184.326,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25-2",
    "data-name": "Rectangle 25-2",
    width: 156.806,
    height: 176.528,
    transform: "translate(2.905 3.9)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 8.79,
    cy: 8.79,
    r: 8.79,
    transform: "translate(72.66 156.571)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 50.485,
    height: 5.165,
    transform: "translate(29.48 66.387)",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 76.195,
    height: 5.165,
    transform: "translate(29.48 81.863)",
    fill: "#724cf9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 68.716,
    height: 5.165,
    transform: "translate(29.48 97.436)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 106.112,
    height: 5.165,
    transform: "translate(29.48 112.598)",
    fill: "#724cf9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 86.479,
    height: 5.165,
    transform: "translate(30.583 127.037)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(202.77 65.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M460.247,612.794a16.912,16.912,0,0,1,1.7,2.046l79.622-1.948,9.289-16.974,27.448,10.67-13.525,31.646a12.848,12.848,0,0,1-13.355,7.707l-89.96-10.867a16.858,16.858,0,1,1-1.222-22.283Z",
    transform: "translate(-431.379 -378.078)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M670.758,434.386l37.262-12.212,10.944-15.009,53.257,3.152,7.819,17.515,28.4,13.419L804.074,522.3l-7.466,75.853c-38.392-19.88-110.042-4.724-110.67-4.477Z",
    transform: "translate(-534.722 -296.59)",
    fill: "#724cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M655.982,565.015l-37.9-15.164.161-.675c.163-.682,16.294-68.09,18.436-78.923,2.231-11.286,10.383-14.406,10.729-14.533l.253-.093,15,4.566,6.588,51.76Z",
    transform: "translate(-511.981 -317.512)",
    fill: "#724cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M816.363,668.41a16.884,16.884,0,0,1,2.658.147l52.707-59.711L865.6,590.5l26.487-12.873,14.011,31.434a12.848,12.848,0,0,1-3.429,15.033l-69.132,58.575a16.858,16.858,0,1,1-17.171-14.257Z",
    transform: "translate(-590.525 -370.181)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M902.1,566.942l-21.986-51.717,8.575-36.024,9.24-11.673a5.323,5.323,0,0,1,4.276.04c3.41,1.371,6.308,5.575,8.625,12.493l20.605,58.692Z",
    transform: "translate(-625.104 -322.465)",
    fill: "#724cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M718.072,304V265.01a52.247,52.247,0,0,1,104.494-.346q0,.173,0,.346V304a7.026,7.026,0,0,1-7.018,7.018H725.09A7.026,7.026,0,0,1,718.072,304Z",
    transform: "translate(-555.148 -212.589)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 38.305,
    cy: 38.305,
    r: 38.305,
    transform: "translate(166.129 20.91)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M696.322,278.924a41.376,41.376,0,0,1,41.33-41.33h7.8a41.376,41.376,0,0,1,41.329,41.33v.78H770.3l-5.621-15.742L763.554,279.7h-8.516l-2.836-7.941-.568,7.941H696.322Z",
    transform: "translate(-545.759 -223.384)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M783.457,339.344a6.914,6.914,0,0,1-.549-7.341c8.263-15.718,19.833-44.761,4.476-62.672l-1.1-1.285h44.585v66.938l-40.5,7.146a7.162,7.162,0,0,1-1.242.11,6.99,6.99,0,0,1-5.664-2.894Z",
    transform: "translate(-582.792 -236.53)",
    fill: "#2f2e41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(62.616 14.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M203.446,123.086a18.691,18.691,0,1,0,18.69,18.691h0a18.691,18.691,0,0,0-18.691-18.691Zm0,5.607a5.607,5.607,0,1,1-5.607,5.607h0a5.607,5.607,0,0,1,5.607-5.607Zm0,26.994a13.617,13.617,0,0,1-11.215-5.985c.09-3.738,7.477-5.8,11.215-5.8s11.125,2.058,11.215,5.8a13.639,13.639,0,0,1-11.215,5.985Z",
    transform: "translate(-184.753 -123.085)",
    fill: "#724cf9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M215.616,378.431c7.7-14.111,26.147-23.047,41.237-14.993a27.3,27.3,0,0,1,13.905,17.617c1.989,8.8-2.2,17.2-6.528,24.6-2.348,4.015-4.921,7.948-6.865,12.183-2.012,4.385-3.451,9.454-1.936,14.225,1.364,4.3,4.784,7.424,8.529,9.722a63.551,63.551,0,0,0,13.105,5.853,77.141,77.141,0,0,0,29.258,3.785,80.018,80.018,0,0,0,14.582-2.357c5.082-1.3,10.069-2.938,15.16-4.205,8.5-2.111,18.19-3.161,26.25,1.08,7.83,4.121,11.334,12.74,12.418,21.125,2,15.483-4.138,31.551-15.222,42.394-5.318,5.2-12.01,9.5-19.3,11.258-6.36,1.534-14.526,1.436-19.587-3.318-5.648-5.306-4.319-13.814.167-19.413,5.725-7.143,15.425-8.858,24.081-9.032,9.846-.2,19.683,1.268,29.524.357a45.349,45.349,0,0,0,13.962-3.368,35.381,35.381,0,0,0,10.522-7.12,46.223,46.223,0,0,0,12.21-21.94c2.453-9.831,1.919-20.164.014-30.039a135.457,135.457,0,0,0-3.914-15.064c-.657-2.086-3.951-1.193-3.288.906,5.865,18.6,9.135,40.1-2.2,57.366a34.158,34.158,0,0,1-20.426,14.7c-9.807,2.437-20.1,1.233-30.067.87-9.48-.345-19.89.027-28.016,5.549-6.667,4.529-11.329,13.143-9.314,21.275,1.943,7.842,9.48,11.82,17.017,12.433,7.909.644,15.691-2.01,22.334-6.161,13.817-8.634,23-23.819,24.926-39.918,1-8.388-.018-17.424-3.822-25.038a24.512,24.512,0,0,0-9.006-10.036,29.62,29.62,0,0,0-12.83-3.954c-10.2-.939-20,2.562-29.675,5.241a82.285,82.285,0,0,1-15.132,2.889,75.571,75.571,0,0,1-14.93-.243,73.515,73.515,0,0,1-14.467-3.211,57.907,57.907,0,0,1-13.132-5.937c-3.629-2.32-6.767-5.644-6.945-10.172-.194-4.911,2.282-9.5,4.637-13.644,4.653-8.178,10.4-16.177,11.613-25.751,1.063-8.375-2.307-16.629-8.126-22.6a30.557,30.557,0,0,0-22.582-9.368,36.617,36.617,0,0,0-23.251,9.768,38.279,38.279,0,0,0-7.842,9.962c-1.052,1.927,1.891,3.65,2.944,1.721Z",
    transform: "translate(-134.091 -209.701)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLight);
export default __webpack_public_path__ + "static/media/contact-light.b9f8e9ee9561f1241a096326f2c60c7a.svg";
export { ForwardRef as ReactComponent };